"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var reactive_vue_1 = require("@formily/reactive-vue");
var vue_1 = require("@formily/vue");
var vue_demi_1 = require("vue-demi");
// @ts-ignore
var Steps_vue_1 = __importDefault(require("./Steps.vue"));
// 全局样式注入标记，确保只注入一次
var isPreviewStyleInjected = false;
/**
 * 注入预览点击模式的全局 CSS 样式
 * 只注入一次，避免重复创建 <style> 标签
 */
var injectPreviewStyles = function () {
    if (isPreviewStyleInjected) {
        return;
    }
    var styleId = 'formily-steps-preview-styles';
    if (document.getElementById(styleId)) {
        isPreviewStyleInjected = true;
        return;
    }
    var style = document.createElement('style');
    style.id = styleId;
    style.textContent = "\n/* Formily Steps \u9884\u89C8\u70B9\u51FB\u6A21\u5F0F\u5168\u5C40\u6837\u5F0F */\n/* \u79FB\u52A8\u7AEF Vant Steps \u7EC4\u4EF6\u9009\u4E2D\u9AD8\u4EAE\u6548\u679C */\n.van-step.step-preview-selected .van-step__circle-container .van-step__circle,\n.van-step.step-preview-selected .van-step__circle-container .van-step__icon {\n  border-color: #1677ff !important;\n  color: #1677ff !important;\n  transform: scale(1.15);\n  transition: all 200ms cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n/* \u9009\u4E2D\u72B6\u6001\u7684\u5706\u5708\u80CC\u666F */\n.van-step.step-preview-selected .van-step__circle-container .van-step__circle {\n  background-color: transparent !important;\n  box-shadow: 0 0 0 2px #1677ff;\n}\n\n/* \u5DF2\u5B8C\u6210\u6B65\u9AA4\u88AB\u9884\u89C8\u9009\u4E2D\u65F6 */\n.van-step--finish.step-preview-selected .van-step__circle-container .van-step__icon {\n  color: #1677ff !important;\n  transform: scale(1.15);\n}\n\n/* \u5F53\u524D\u6B65\u9AA4\u88AB\u9884\u89C8\u9009\u4E2D\u65F6 */\n.van-step--process.step-preview-selected .van-step__circle-container .van-step__circle {\n  border-color: #1677ff !important;\n  background-color: #1677ff !important;\n  transform: scale(1.15);\n}\n";
    document.head.appendChild(style);
    isPreviewStyleInjected = true;
};
/**
 * Formily 包装的 Steps 组件
 *
 * 支持 clickablePreview 模式：
 * - 点击步骤不会改变实际进度（value），只会触发预览效果
 * - 再次点击已选中的步骤会取消选中
 * - 预览索引会自动写入到 {fieldName}_preview 字段中
 *
 * 示例：假设 Steps 字段标识为 formTab
 * - 读取当前实际进度：$form.values.formTab
 * - 读取预览点击的索引：$form.values.formTab_preview（点击哪步就是几，取消选中时为 null）
 */
var FormilySteps = (0, reactive_vue_1.observer)((0, vue_demi_1.defineComponent)({
    name: 'FormilySteps',
    props: [
        'value',
        'direction',
        'options',
        'newVersion',
        'newVersionMarginBottom',
        'newVersionDescriptionFontSize',
        'allowMultiline',
        'maxHeight',
        'maxTitleWidth',
        'enableScroll',
        'clickable',
        'disabled',
        'clickablePreview',
    ],
    setup: function (curProps, _a) {
        var attrs = _a.attrs, emit = _a.emit;
        var field = (0, vue_1.useField)();
        // 如果启用了预览点击模式，注入全局样式
        (0, vue_demi_1.onMounted)(function () {
            if (curProps.clickablePreview) {
                injectPreviewStyles();
            }
        });
        /**
         * 处理预览变化事件
         * 自动将预览索引写入到表单字段 {fieldName}_preview 中
         */
        var handlePreviewChange = function (previewIndex) {
            var _a, _b, _c;
            try {
                var fieldInstance = field.value;
                if (fieldInstance && fieldInstance.form) {
                    // 获取字段名称，优先使用 props.name
                    var fieldName = ((_a = fieldInstance.props) === null || _a === void 0 ? void 0 : _a.name)
                        || ((_b = fieldInstance.path) === null || _b === void 0 ? void 0 : _b.toString())
                        || ((_c = fieldInstance.address) === null || _c === void 0 ? void 0 : _c.toString());
                    if (fieldName) {
                        // 构建预览字段的路径：{fieldName}_preview
                        var previewFieldPath = "".concat(fieldName, "_preview");
                        // 使用 setValuesIn 设置预览字段的值
                        fieldInstance.form.setValuesIn(previewFieldPath, previewIndex);
                    }
                }
            }
            catch (e) {
                console.debug('[FormilySteps] 更新预览字段失败:', e);
            }
            // 继续触发外部的 preview-change 事件
            emit('preview-change', previewIndex);
        };
        return function () { return (0, vue_1.h)(Steps_vue_1.default, {
            attrs: __assign(__assign({}, curProps), attrs),
            on: {
                input: function (val) {
                    emit('input', val);
                    emit('change', val);
                },
                change: function (val) {
                    emit('change', val);
                },
                'step-click': function (index) {
                    emit('step-click', index);
                },
                'preview-change': handlePreviewChange,
            },
        }, {}); };
    },
}));
exports.default = FormilySteps;
